import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
/* empty css          */
const LABELS = {
  query: "QRY",
  mutation: "MUT",
  subscription: "SUB"
};
const MethodPill = (t0) => {
  const $ = c(7);
  let operation;
  let rest;
  if ($[0] !== t0) {
    ({
      operation,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = operation;
    $[2] = rest;
  } else {
    operation = $[1];
    rest = $[2];
  }
  const t1 = `graphiql-method-pill graphiql-method-pill-${operation}`;
  const t2 = LABELS[operation];
  let t3;
  if ($[3] !== rest || $[4] !== t1 || $[5] !== t2) {
    t3 = /* @__PURE__ */ jsx("span", { className: t1, ...rest, children: t2 });
    $[3] = rest;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export {
  MethodPill
};
//# sourceMappingURL=index.js.map
